'use client';

import type { MediaEntityType } from '@/entities/product';

import { getBulletMediaUrl, MAX_VISIBLE_THUMBNAILS } from '../../lib';
import { useGalleryStore } from '../../model';

export type MoreButtonProps = Readonly<{
    media: MediaEntityType[];
    productName: string;
}>;

export const MoreButton = ({ media, productName }: MoreButtonProps) => {
    const openModal = useGalleryStore(s => s.openModal);
    const buttonMedia = media[MAX_VISIBLE_THUMBNAILS - 1];

    if (media.length <= MAX_VISIBLE_THUMBNAILS) return null;

    const bulletUrl = getBulletMediaUrl(buttonMedia);

    const handleClick = () => {
        openModal(MAX_VISIBLE_THUMBNAILS - 1);
    };

    return (
        <button
            aria-label={`Open media gallery at item ${MAX_VISIBLE_THUMBNAILS}.`}
            className="pdp-gallery__bullet pdp-gallery__bullet-more"
            onClick={handleClick}
        >
            <img
                width="100%"
                src={bulletUrl}
                loading="lazy"
                alt={`${productName} ${buttonMedia.type} thumbnail ${MAX_VISIBLE_THUMBNAILS}`}
            />

            <div className="pdp-gallery__bullet-more-overlay">
                <span className="pdp-gallery__bullet-more-label">
                    +{media.length - (MAX_VISIBLE_THUMBNAILS - 1)} more
                </span>
            </div>
        </button>
    );
};
